<template>
  <div class="d-flex align-center justify-space-between">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-on="on" icon @click="updateAnnouncementData('editText')" class="ml-1" v-if="!params.data.isArchived">
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
      </template> 
      <span>Edit announcement</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-switch
          v-if="!params.data.isArchived"
          v-on="on"
          class="ml-3"
          v-model="params.data.isActive"
          @change="updateAnnouncementData('toggle')"
          :label="params.label"
          color="primary"
        ></v-switch>
      </template> 
      <span>{{ switchTooltip }}</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-on="on" icon @click="updateAnnouncementData('archive')" class="ml-1" v-if="!params.data.isArchived">
          <v-icon color="primary">mdi-delete</v-icon>
        </v-btn>
      </template> 
      <span>Archive announcement</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-on="on" icon @click="updateAnnouncementData('restore')" class="ml-1" v-if="params.data.isArchived">
          <v-icon color="primary">mdi-restore</v-icon>
        </v-btn>
      </template> 
      <span>Restore announcement</span>
    </v-tooltip>
  </div>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  methods: {
    updateAnnouncementData(type){
      let vm = this;
      let confirmation = "";
      if(type === "toggle"){
        let status = "";
        if(!vm.params.data.isActive) status = "disable";
        else status = "enable";
        confirmation = confirm(`Are you sure you want to ${status} the announcement?`);
        if (confirmation) {
          vm.params.api.dispatchEvent({
            type: 'toggle',
            data: vm.params.data,
          });
        }
      }
      else if(type === "archive"){
        confirmation = confirm(`Are you sure you want to archive the announcement?`);
        if (confirmation) {
          vm.params.api.dispatchEvent({
            type: 'archive',
            data: vm.params.data,
          });
        }
      }
      else if(type === "restore"){
        vm.params.api.dispatchEvent({
          type: 'restore',
          data: vm.params.data,
        });
      }
      else if(type === "editText"){
        vm.params.api.dispatchEvent({
          type: 'editText',
          data: vm.params.data,
        });
      }
    }
  },
  computed: {
    switchTooltip() {
      let vm = this;
      return vm.params.data.isActive ? "Turn off announcement" : "Turn on announcement";
    }
  }
});
</script>